import Component from '@cell/cell-core/component/component';
import './product-size-chart.scss';

class ProductSizeChart extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    globalThis.on('load', this.render.bind(this));
  }

  render() {
    const headerRow = Object.keys(this.parsedDataset.rows[0]);
    const bodyRows = this.parsedDataset.rows.map((row) => Object.values(row));

    const tableElement = this.querySelector('table');

    const locale = window.Shopify.locale;
    const translations = JSON.parse(
      this.querySelector('script[type="application/json"]').textContent,
    );

    tableElement.innerHTML = `
      <thead>
        <tr>
          ${headerRow
            .map(
              (value, index) => `
              <th>
                ${translations[value]?.[locale] ?? ''}
                ${index > 1 ? `(${index - 1})` : ''}
              </th>
            `,
            )
            .join('')}
        </tr>
      </thead>

      <tbody>
        ${bodyRows
          .map(
            (row) => `
              <tr>
                ${row.map((value) => `<td>${value}</td>`).join('')}
              </tr>
            `,
          )
          .join('')}
      </tbody>
    `;
  }
}

customElements.define('product-size-chart', ProductSizeChart);
